"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get url parameter
 * @param getParam
 */
function getUrlParameter(getParam) {
    return new URL(window.location.href).searchParams.get(getParam);
}
exports.getUrlParameter = getUrlParameter;
/**
 * Get current uri
 */
exports.getCurrentUri = () => `${document.location.protocol}//${document.location.host}${document.location.pathname}`;
/** Replace current url with no reload */
exports.cleanUrl = (urlPath) => {
    window.history.pushState({
        html: document.getElementsByTagName('html')[0].innerHTML,
        pageTitle: document.title
    }, '', urlPath);
};
//# sourceMappingURL=url.js.map